<template>
  <BoxWithTitle customClass="header-info">
    <template v-slot:header>
      <v-toolbar-title>
        {{ $t('sites.siteInfo') }}
      </v-toolbar-title>
    </template>
    <template v-slot:content>
      <SiteForm
        ref="mainForm"
        :populateWith="defaultData"
        :isForm="formEditable"
        :isFormDirty="isFormDirty"
        @dirtyChanged="isFormDirty = $event"
        @validChanged="isFormValid = $event"
        @sendData="onSendData"
      />
      <!-- Button de sauvegarde de site info -->
      <v-row
        :vIf="formEditable"
        align="center"
        justify="end"
        class="mr-1 pa-10"
      >
        <v-btn
          :disabled="!isFormValid || !isFormDirty"
          type="submit"
          color="secondary"
          @click.prevent="onClickUpdate"
        >
          {{ $t('forms.btn.save') }}
        </v-btn>
      </v-row>
    </template>
  </BoxWithTitle>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FormPageMixin from '@/mixins/FormPageMixin';
import BoxWithTitle from '@/components/shared/containers/VBoxWithTitle.vue';
import SiteForm from '@/components/forms/SiteForm.vue';
import { cloneDeep } from 'lodash';

export default {
    components: {
        BoxWithTitle,
        SiteForm,
    },
    mixins: [FormPageMixin],
    data() {
        return {
            updatedData: null,
            clientStatus: null,
        };
    },
    computed: {
        ...mapGetters(['site', 'hasPermission']),
        defaultData() {
            return this.site;
        },
    },
    watch: {
        formEditable: {
            immediate: true,
            async handler() {
                if (this.formEditable) this.activePreventQuitFormular();
                else this.disablePreventQuitFormular();
            },
        },
    },
    async created() {
        if (this.defaultData.client) {
            this.clientStatus = this.defaultData.active;
        }
    },
    methods: {
        ...mapActions({
            reloadSite: 'getSiteInfo',
            disablePreventQuitFormular: 'disablePreventQuitFormular',
            activePreventQuitFormular: 'activePreventQuitFormular',
        }),
        async onClickUpdate() {
            const {
                id: siteId,
                name,
                deliveryAccountNumber,
                active: status,
                initialSiteStatus,
            } = this.updatedData;
            if (initialSiteStatus) { await this.$rq.updateSite(siteId, this.updatedData); }
            if (initialSiteStatus !== status) { await this.$rq.updateSiteStatus(siteId, { status }); }

            this.$toasted.global.toast_success({
                message: this.$t('msg.siteModified', {
                    data: `${name} [${deliveryAccountNumber}]`,
                }),
            });
            this.formEditable = false;
            this.reloadSite(siteId);
            this.disablePreventQuitFormular();
        },
        onSendData(payload) {
            this.isFormDirty = true;
            const {
                address,
                city,
                country,
                postalCode,
                province,
                streetNumber,
            } = payload || {};
            if (
                address
                && city
                && country
                && postalCode
                && province
                && streetNumber
            ) {
                this.isFormValid = !!payload.isFormValid;
            }
            const data = cloneDeep(payload);
            delete data.isFormValid;
            this.updatedData = { ...this.updatedData, ...data };
            this.activePreventQuitFormular();
        },
    },
};
</script>
